<template>
  <div id="equipment-config" class="equipment-config-container">
    <!-- 筛选栏 -->
    <div class="filter-bar">
      <el-form :inline="true" :model="queryParams" class="search-form b-mt-20" label-width="106px">
        <el-form-item label="医疗机构名称:">
          <el-select v-model="queryParams.orgCode" placeholder="请选择医疗机构">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in orgList" :key="'org' + index" :label="item.orgName"
              :value="item.orgCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同签署年度:">
          <el-select v-model="queryParams.year" placeholder="请选择合同签署年度">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in yearList" :key="'year' + index" :label="item.year" :value="item.year">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采购金额区间:">
          <el-select v-model="queryParams.amount" placeholder="请选择采购金额区间">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in amountList" :key="'amount' + index" :label="item.amount"
              :value="item.amount">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="queryAll">查询</el-button>
        <el-button type="info" @click="resetQuery">重置</el-button>
      </el-form>
    </div>

    <!-- 统计与表格区域 -->
    <div class="content-wrapper">
      <!-- 左侧统计卡片 -->
      <div class="stats-section">
        <!-- 设备品目分布 -->
        <div class="chart-card">
          <h3 class="chart-title">设备品目分布</h3>
          <div class="chart-container" style="height: 231px;">
            <div id="originChart" style="width: 100%; height: 100%;"></div>
          </div>
          <!-- <div class="chart-stats">
            <span v-for="item in itemList" :key="item.count">{{ item.name+'（'+item.count+'）' }}</span>
          </div> -->
        </div>

        <!-- 采购金额区间分布 -->
        <div class="chart-card">
          <h3 class="chart-title">采购金额区间分布</h3>
          <div class="chart-container" style="height: 231px;">
            <div id="priceChart" style="width: 100%; height: 100%;"></div>
          </div>
          <!-- <div class="chart-stats">
            <span v-for="item in priceList" :key="item.count">{{ item.name }}</span>
          </div> -->
        </div>

      </div>

      <!-- 设备清单 -->
      <div class="table-section">
        <div class="table-card">
          <div class="table-header">
            <span>设备清单</span>
            <div class="table-actions">
              <button class="action-btn">
                <i class="el-icon-download"></i> 导出
              </button>
            </div>
          </div>
          <el-table :data="tableData" border stripe style="width: 100%">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="orgName" label="医疗机构名称"></el-table-column>
            <el-table-column prop="assetsCode" label="资产编码"></el-table-column>
            <el-table-column prop="item" label="设备品目"></el-table-column>
            <el-table-column prop="brand" label="品牌"></el-table-column>
            <el-table-column prop="purchaseAmount" label="采购金额">
              <template slot-scope="scope">
                <span class="price">¥{{ scope.row.purchaseAmount }}万元</span>
              </template>
            </el-table-column>
            <el-table-column prop="deviceStatus" label="设备状态">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.deviceStatus === '在用'" type="success">在用</el-tag>
                <el-tag v-else type="danger">异常</el-tag>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="pagination" background @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="page" :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="content-wrapper" style="margin-top: 20px;">
      <div class="stats-section">

        <!-- 医院设备数量及占比 -->
        <div class="chart-card">
          <h3 class="chart-title">医院设备数量及占比</h3>
          <div class="chart-container" style="height: 250px;">
            <div id="deviceChart" style="width: 100%; height: 100%;"></div>
          </div>
          <!-- <div class="chart-stats">
            <span v-for="item in deviveCountList" :key="item.count">{{ item.name  + '（'+ item.percentage + '%）' }}</span>
          </div> -->
        </div>

        <!-- 医疗机构人员配置学历信息分析 -->
        <div class="chart-card">
          <h3 class="chart-title">医疗机构人员配置学历信息分析</h3>
          <div class="chart-container" style="height: 250px;">
            <div id="educationChart" style="width: 100%; height: 100%;"></div>
          </div>
          <!-- <div class="chart-stats">
            <span v-for="item in educationList" :key="item.count">{{ item.name  + '（'+ item.percentage + '%）' }}</span>
          </div> -->
        </div>
      </div>
      <div class="table-section">
        <!-- 医疗机构人员配置职称信息分析 -->
        <div class="chart-card">
          <h3 class="chart-title">医疗机构人员配置职称信息分析</h3>
          <div class="chart-container" style="height: 250px;">
            <div id="titleChart" style="width: 100%; height: 100%;"></div>
          </div>
          <!-- <div class="chart-stats">
            <span v-for="item in titleList" :key="item.count">{{ item.name  + '（'+ item.percentage + '%）' }}</span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryItemList, queryOrgList, queryYearList, queryPriceList, devicePage, deviceCountList, titleList, educationList } from '@/api/modules/dataView'
export default {
  name: 'EquipmentConfig',
  mounted() {
    this.queryOrg();
    this.queryYear();
    this.queryItem();
    this.queryPrice();
    this.queryPage();
    this.queryDeviceCount();
    this.queryTitleList();
    this.queryEducationList();
    // 窗口大小变化时重新渲染图表
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    // 组件销毁前移除事件监听
    window.removeEventListener('resize', this.handleResize);

    // 销毁图表实例
    if (this.originChart) this.originChart.dispose();
    if (this.priceChart) this.priceChart.dispose();
    if (this.enterpriseChart) this.enterpriseChart.dispose();
    if (this.deviceChart) this.deviceChart.dispose();
    if (this.titleChart) this.titleChart.dispose();
    if (this.educationChart) this.educationChart.dispose();
  },

  data() {
    return {
      originChart: null,
      priceChart: null,
      enterpriseChart: null,
      deviceChart: null,
      titleChart: null,
      educationChart: null,
      queryParams: {
        orgCode: '',
        year: '',
        amount: '',
        pageNo: 1,
        pageSize: 10
      },
      itemList: [],
      orgList: [],
      yearList: [],
      amountList: [
        {
          amount: '0-500万'
        },
        {
          amount: '501-1000万'
        },
        {
          amount: '1001-1500万'
        },
        {
          amount: '1501-2000万'
        },
        {
          amount: '>2000万'
        }
      ],
      priceList: [],
      page: 1,
      totalCount: 1,
      tableData: [],
      deviveCountList: [],
      titleList: [],
      educationList: []
    };
  },

  methods: {
    handleSizeChange(val) {
      this.queryParams.pageSize = val
      this.queryPage()
    },
    handleCurrentChange(val) {
      this.queryParams.pageNo = val
      this.queryPage()
    },
    queryPage() {
      devicePage(this.queryParams).then(data => {
        this.tableData = data.results || []
        this.totalCount = data.totalCount || 0
      })
    },
    queryAll() {
      this.itemList = [];
      this.priceList = [];
      this.queryItem();
      this.queryPrice();
      this.queryPage();
      this.queryDeviceCount();
      this.queryTitleList();
      this.queryEducationList();
    },
    resetQuery() {
      this.queryParams = {
        orgCode: '',
        year: '',
        amount: '',
        pageNo: 1,
        pageSize: 10
      }
      this.queryAll();
    },
    queryItem() {
      queryItemList(this.queryParams).then(data => {
        this.itemList = data || []
        this.$nextTick(() => {
          this.initOriginChart()
        })
      })
    },
    queryDeviceCount() {
      deviceCountList(this.queryParams).then(data => {
        this.deviveCountList = data || []
        this.$nextTick(() => {
          this.initDeviceChart()
        })
      })
    },
    queryTitleList() {
      titleList(this.queryParams).then(data => {
        this.titleList = data || []
        this.$nextTick(() => {
          this.initTitleChart()
        })
      })
    },
    queryEducationList() {
      educationList(this.queryParams).then(data => {
        this.educationList = data || []
        this.$nextTick(() => {
          this.initEducationChart()
        })
      })
    },
    queryPrice() {
      queryPriceList(this.queryParams).then(data => {
        this.priceList = data || []
        this.$nextTick(() => {
          this.initPriceChart()
        })
      })
    },
    queryOrg() {
      queryOrgList().then(data => {
        this.orgList = data || []
      })
    },
    queryYear() {
      queryYearList().then(data => {
        this.yearList = data || []
      })
    },
    handleResize() {
      if (this.originChart) this.originChart.resize();
      if (this.priceChart) this.priceChart.resize();
      if (this.enterpriseChart) this.enterpriseChart.resize();
      if (this.deviceChart) this.deviceChart.resize();
      if (this.titleChart) this.titleChart.resize();
      if (this.educationChart) this.educationChart.resize();
    },
    // 设备品目分布饼图
    initOriginChart() {
      const originChartElement = document.getElementById('originChart');
      this.originChart = this.$echarts.init(originChartElement);
      const option = {
        tooltip: {
          trigger: 'item',
          // formatter: '{b}: {c}台 ({d}%)'
          formatter: '{b}'
        },
        series: [
          {
            name: '设备品目分布',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 0,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: true,
              position: 'outside',
              formatter: '{b}',
              fontSize: '12',
              color: '#333'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: this.itemList.map(item => ({
              value: item.count,
              name: item.name+'（'+item.count+'）'
            }))
          }
        ]
      };
      this.originChart.setOption(option);
    },
    // 采购金额分布饼图
    initPriceChart() {
      const priceChartElement = document.getElementById('priceChart');
      this.priceChart = this.$echarts.init(priceChartElement);

      // const option = {
      //   tooltip: {
      //     trigger: 'item',
      //     // formatter: '{b}: {c}台 ({d}%)'
      //     formatter: '{b}'
      //   },
      //   series: [
      //     {
      //       name: '采购金额区间分布',
      //       type: 'pie',
      //       radius: ['40%', '70%'],
      //       center: ['50%', '50%'],
      //       avoidLabelOverlap: false,
      //       itemStyle: {
      //         borderRadius: 0,
      //         borderColor: '#fff',
      //         borderWidth: 2
      //       },
      //       label: {
      //         show: true,
      //         position: 'outside',
      //         formatter: '{b}',
      //         fontSize: '12',
      //         color: '#333'
      //       },
      //       emphasis: {
      //         label: {
      //           show: true,
      //           fontSize: '14',
      //           fontWeight: 'bold'
      //         }
      //       },
      //       labelLine: {
      //         show: false
      //       },
      //       data: this.priceList.map(item => ({
      //         value: item.count,
      //         name: item.name
      //       }))
      //     }
      //   ]
      // };
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: [],
          right: '3%',
          top: '10%',
          textStyle: {
            fontSize: 10,
            color: '#606266'
          },
          itemWidth: 12
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.priceList.map(item => {
            return item.name && item.name.split(':')[0]
          }),
          axisLine: {
            show: true,
            lineStyle: {
              color: '#606266'
            }
          },
          axisLabel: {
            rotate: 45
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: [
          {
            name: '采购金额区间分布',
            type: 'bar',
            data: this.priceList.map(item => item.count),
            label: {
              show: true,
              position: 'top',
              formatter: '{c}',
              fontSize: '12',
              color: '#333'
            }
          }
        ]
      }
      this.priceChart.setOption(option);
    },
    // 生产企业TOP10柱状图
    initEnterpriseChart() {
      const enterpriseChartElement = document.getElementById('enterpriseChart');
      this.enterpriseChart = this.$echarts.init(enterpriseChartElement);

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: '{b}: {c}台'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        yAxis: {
          type: 'category',
          data: ['GE医疗', '西门子', '飞利浦', '联影医疗', '迈瑞医疗', '东软医疗', '万东医疗', '鱼跃医疗', '乐普医疗', '理邦仪器'],
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            margin: 10
          },
          interval: 0,
          inverse: true
        },
        series: [
          {
            name: '设备数量',
            type: 'bar',
            barWidth: 20,
            barCategoryGap: '30%',
            data: [95, 85, 75, 65, 55, 45, 35, 25, 20, 15],
            itemStyle: {
              color: '#0d6efd'
            }
          }
        ]
      };

      this.enterpriseChart.setOption(option);
    },
    // 医院设备数量及占比
    initDeviceChart() {
      const deviceChartElement = document.getElementById('deviceChart');
      this.deviceChart = this.$echarts.init(deviceChartElement);
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}'
        },
        series: [
          {
            name: '医院设备数量及占比',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 0,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: true,
              position: 'outside',
              formatter: '{b}',
              fontSize: '12',
              color: '#333'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: this.deviveCountList.map(item => ({
              value: item.count,
              name: item.name  + '（'+ item.percentage + '%）'
            }))
          }
        ]
      };
      this.deviceChart.setOption(option);
    },
    // 医疗机构人员配置职称信息分析
    initTitleChart() {
      const titleChartElement = document.getElementById('titleChart');
      this.titleChart = this.$echarts.init(titleChartElement);
      // const option1 = {
      //   tooltip: {
      //     trigger: 'item',
      //     formatter: '{b}'
      //   },
      //   series: [
      //     {
      //       name: '医疗机构人员配置职称信息分析',
      //       type: 'pie',
      //       radius: ['40%', '70%'],
      //       center: ['50%', '50%'],
      //       avoidLabelOverlap: false,
      //       itemStyle: {
      //         borderRadius: 0,
      //         borderColor: '#fff',
      //         borderWidth: 2
      //       },
      //       label: {
      //         show: true,
      //         position: 'outside',
      //         formatter: '{b}',
      //         fontSize: '12',
      //         color: '#333'
      //       },
      //       emphasis: {
      //         label: {
      //           show: true,
      //           fontSize: '14',
      //           fontWeight: 'bold'
      //         }
      //       },
      //       labelLine: {
      //         show: false
      //       },
      //       data: this.titleList.map(item => ({
      //         value: item.count,
      //         name: item.name  + '（'+ item.percentage + '%）'
      //       }))
      //     }
      //   ]
      // };
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: [],
          right: '3%',
          top: '10%',
          textStyle: {
            fontSize: 10,
            color: '#606266'
          },
          itemWidth: 12
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.titleList.map(item => item.name),
          axisLine: {
            show: true,
            lineStyle: {
              color: '#606266'
            }
          },
          axisLabel: {
            rotate: 45
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: [
          {
            name: '医疗机构人员配置职称信息分析',
            type: 'bar',
            data: this.titleList.map(item => item.count),
            label: {
              show: true,
              position: 'top',
              formatter: '{c}',
              fontSize: '12',
              color: '#333'
            }
          }
        ]
      }
      this.titleChart.setOption(option);
    },
    // 医疗机构人员配置学历信息分析
    initEducationChart() {
      const educationChartElement = document.getElementById('educationChart');
      this.educationChart = this.$echarts.init(educationChartElement);
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}'
        },
        series: [
          {
            name: '医疗机构人员配置学历信息分析',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 0,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: true,
              position: 'outside',
              formatter: '{b}',
              fontSize: '12',
              color: '#333'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: this.educationList.map(item => ({
              value: item.count,
              name: item.name  + '（'+ item.percentage + '%）'
            }))
          }
        ]
      };
      this.educationChart.setOption(option);
    }
  }
}
</script>

<style lang="scss">
.equipment-config-container {
  padding: 20px;
  background-color: #f5f7fa;
}

/* 筛选栏 */
.filter-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
  padding: 20px;
  background-color: #fff;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.filter-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 200px;
  flex: 1;
  max-width: 300px;

  label {
    font-size: 14px;
    color: #666;
  }

  .input-group {
    display: flex;
  }

  input,
  select {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 0;
    font-size: 14px;
    height: 36px;
  }

  .search-btn {
    padding: 0 15px;
    background-color: #0d6efd;
    color: #fff;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
  }
}

.query-btn {
  padding: 8px 25px;
  background-color: #0d6efd;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 14px;
  height: 36px;
  margin-bottom: 0;
}

.query-btn-wrapper {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: auto;
  flex: none;
  max-width: auto;
}

.query-btn-wrapper button {
  margin-top: auto;
}

/* 统计与表格区域 */
.content-wrapper {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  width: 100%;
}

/* 左侧统计卡片 */
.stats-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 0 0 calc(40% - 10px);
  min-width: 350px;
}

/* 右侧设备配置清单 */
.table-section {
  flex: 0 0 calc(60% - 10px);
  min-width: 350px;
}

.chart-card {
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 0;

  .chart-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #333;
  }

  .chart-container {
    position: relative;
    width: 100%;
    height: 100%;
    margin-bottom: 15px;
  }

  .chart-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    font-size: 12px;
    color: #666;
  }
}

/* 右侧设备配置清单 */
.table-section {
  flex: 1;
  min-width: 500px;
}

.table-card {
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 0;
  overflow: hidden;
  padding: 0;
  margin-bottom: 20px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.table-header span {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.table-actions {
  display: flex;
  gap: 10px;
}

.action-btn {
  padding: 5px 15px;
  background-color: #fff;
  border: 1px solid #ddd;
  cursor: pointer;
  font-size: 14px;
  border-radius: 0;
}

/* 表格样式 */
.table-scroll-container {
  overflow-x: auto;
  padding: 0;
  margin: 0;
}

.equipment-table th:nth-child(1),
.equipment-table td:nth-child(1) {
  text-align: center;
  width: 80px;
  /* 序号列固定宽度 */
}

.equipment-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: fixed;
  /* 设置固定布局 */
}

.equipment-table th {
  background-color: #f8f9fa;
  border: 1px solid #eee;
  padding: 12px 20px;
  text-align: left;
  font-weight: bold;
  color: #333;
  line-height: 1.4;
  white-space: nowrap;
  /* 防止表头自动换行 */
  min-width: 100px;
  /* 最小宽度，可根据需要调整 */
}

.equipment-table td {
  border: 1px solid #eee;
  padding: 12px 20px;
  text-align: left;
  color: #666;
  line-height: 1.4;
  white-space: nowrap;
  /* 防止单元格自动换行 */
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 状态标签样式 */
.status {
  padding: 3px 10px;
  border-radius: 0;
  font-size: 12px;
  font-weight: normal;
}

.status-in-use {
  background-color: #e6f4ea;
  color: #198754;
}

.status-idle {
  background-color: #fff3cd;
  color: #ffc107;
}

.status-scrap {
  background-color: #f8d7da;
  color: #dc3545;
}

/* 金额样式 */
.price {
  font-weight: bold;
}

.price-high {
  color: #dc3545;
}

/* 操作按钮 */
.action-col {
  text-align: center;
}

.detail-btn {
  padding: 2px 10px;
  background-color: #0d6efd;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 12px;
  border-radius: 0;
}

/* 表格底部 */
.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-top: 1px solid #eee;
  background-color: #f8f9fa;
}

.data-info {
  font-size: 14px;
  color: #666;
}

.highlight {
  color: #0d6efd;
  font-weight: bold;
}

/* 分页样式 */
.pagination {
  display: flex;
  gap: 5px;
}

.page-btn {
  padding: 5px 10px;
  background-color: #fff;
  border: 1px solid #ddd;
  cursor: pointer;
  font-size: 14px;
  border-radius: 0;
}

.page-btn:hover {
  background-color: #f8f9fa;
}

.page-btn.active {
  background-color: #0d6efd;
  color: #fff;
  border-color: #0d6efd;
}

.page-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .content-wrapper {
    flex-direction: row;
  }

  .stats-section {
    flex: 0 0 calc(30% - 10px);
  }

  .table-section {
    flex: 0 0 calc(70% - 10px);
  }

  .filter-bar {
    justify-content: space-between;
  }

  .filter-item {
    min-width: 180px;
  }
}

@media (max-width: 992px) {
  .content-wrapper {
    flex-direction: column;
  }

  .stats-section,
  .table-section {
    flex: 0 0 100%;
  }

  .filter-bar {
    justify-content: space-between;
  }

  .filter-item {
    min-width: 180px;
  }
}

@media (max-width: 768px) {
  .equipment-config-container {
    padding: 10px;
  }

  .filter-bar {
    padding: 15px;
    gap: 15px;
  }

  .filter-item {
    min-width: 100%;
    max-width: none;
    flex: none;
  }

  .stats-section {
    flex-direction: column;
  }

  .chart-card {
    flex: none;
    width: 100%;
  }

  .table-section {
    min-width: 100%;
  }

  .query-btn-wrapper {
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: auto;
    flex: none;
    max-width: auto;
  }

  .query-btn-wrapper button {
    margin-top: auto;
  }
}
</style>